import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { webUrlNode } from "../../../../../../constants/appInfo";
import BatchRow from "./BatchRow";

export default function LinkHwToBatches({ homeworkId,  onClose }) {

  const [items,setItems] = useState([]);
  const [tempSelected,setTempSelected] = useState([]);
  const [loading,setLoading] = useState(false);
const [linkedMap,setLinkedMap] = useState({});
  const AppToken = useSelector((s)=>s?.app?.app?.AppToken);
  const coursePostId = useSelector((s)=>s?.course?.course?.postId);
  const currentToken = useSelector((s)=>s?.user?.user?.token);
  const userEmail = useSelector((s)=>s?.user?.user?.user_email);

  useEffect(()=>{

    if( !coursePostId) return;

    loadData();

  },[coursePostId]);


 async function loadData(){

    setLoading(true);

    try{

      const res = await axios.get(
        `${webUrlNode}/api/batches/?appToken=${AppToken}`,
        {
          params:{ coursePostId,userEmail,currentToken }
        }
      );

      const batches = res.data.items || [];
      setItems(batches);

      // detect linked batches
      const map = {};

      await Promise.all(
        batches.map(async(b)=>{

          const r = await axios.get(
            `${webUrlNode}/api/batches/${b.batchId}/homework?appToken=${AppToken}`
          );

          const match = r.data.items?.find(
            x => String(x.homeworkId) === String(homeworkId)
          );

          if(match){
            map[b.batchId] = match.id;
          }

        })
      );

      setLinkedMap(map);

    }
    catch(e){
      console.error(e);
    }

    setLoading(false);

  }



  




  return(

    <div style={modalWrapper}>

      <div style={modalStyle}>

        <div className="modalHeader">
          <h3>Link Homework to Batches</h3>
          <button className="closeBtn" onClick={onClose}>✕</button>
        </div>

      {loading && <div>Loading...</div>}

        {!loading && items.map((b,i)=>{

          const checked = !!linkedMap[b.batchId];

          return(
            <BatchRow
              key={b.batchId}
              batch={b}
              homeworkId={homeworkId}
              index={i}
              checked={checked}
              
              linkedMap={linkedMap}
              setLinkedMap={setLinkedMap}
            />
          )

        })}
        

      </div>
<style>{`
.closeBtn{
  border:none;
  background:#f5f5f5;
  width:32px;
  height:32px;
  border-radius:6px;
  cursor:pointer;
}

.closeBtn:hover{
  background:#eaeaea;
}
.modalHeader{
display:flex;
justify-content:space-between;
margin-bottom:10px;
}`}</style>
    </div>

  );

}


/* ------------------------------------ */





/* ------------------------------------ */

const modalWrapper={
position:"fixed",
inset:0,
background:"rgba(0,0,0,0.05)",
display:"flex",
justifyContent:"center",
alignItems:"center",
zIndex:1000
}

const modalStyle={
width:600,
background:"#fff",
padding:20,
borderRadius:8
}